import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function FailedMethodsSection() {
  const failures = [{
    title: "Las rutinas de 'baño y leche' fallan",
    desc: 'porque no consideran el estado de cortisol (hormona del estrés) en la sangre de tu bebé.'
  }, {
    title: "El método de 'dejarlo llorar' genera",
    desc: 'un sueño superficial y fragmentado que lo hace despertar al menor ruido.'
  }, {
    title: 'Acostarlo de espaldas directamente',
    desc: 'activa su instinto de caída, haciendo que abra los brazos y se despierte al instante.'
  }, {
    title: "Intentar que la casa esté en 'silencio total'",
    desc: 'hace que cualquier pequeño crujido de la madera sea una alarma para su cerebro.'
  }];
  return <section className="bg-cream-dark py-24 px-6" data-id="element-49">
      <div className="max-w-4xl mx-auto" data-id="element-50">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-51">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-52">
            Por qué lo que has intentado no funciona
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto rounded-full" data-id="element-53"></div>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-2" data-id="element-54">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream p-8 rounded-2xl shadow-md border border-navy/5 flex items-start gap-4" data-id="element-55">
              <XCircle className="w-6 h-6 text-red-800/60 shrink-0 mt-1" data-id="element-56" />
              <div data-id="element-57">
                <h3 className="font-bold text-navy text-lg mb-2" data-id="element-58">
                  {item.title}
                </h3>
                <p className="text-navy/70 leading-relaxed" data-id="element-59">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}